
























// Importing components
import LayoutApp from '@/layputs/LayoutApp.vue';
import BaseCard from '@/ui/BaseCard.vue';
import TheFormAddresses from '@/components/addresses/TheFormAddresses.vue';
// Importing functions
import {validateAddress} from '@/ts/profile/addresses/validate-address';
import {postAddress} from '@/ts/profile/addresses/post-address';

export default {
    name: 'PageAddresseesCreate',
    components: {
        LayoutApp,
        BaseCard,
        TheFormAddresses,
    },
    props: {},
    data() {
        return {
            data: {},
            errors: [],
            items: [],
        };
    },
    methods: {
        onSubmit() {
            this.errors = [];

            validateAddress(this.errors, this.data);

            if (this.errors.length === 0) {
                // Starting loading animation
                this.$store.dispatch('setLoadingOn');
                postAddress(this.errors, this.data).then(() => {
                    this.$router.push({ name: 'addresses' });
                }).finally(() => {
                    this.$store.dispatch('setLoadingOff');
                });
            }
        },
    },
    created() {
        // Initializing the items object
        this.items = [{
            text: 'Адреси',
            to: { path: '/addresses' },
        }, {
            text: 'Създаване',
        }];
        // Initializing the data object
        this.data = {
            name: '', phone: '', address: '', town_ekatte: '',
        };
    },
};
